<template>
  <poster-dashboard-widget
    class="poster-dashboard-demands-synthesis"
    v-bind="$attrs"
    direction="column"
  >
    <pui-common-spinner
      v-if="loader.messages.length"
      :message="loader.messages[0].message"
      position="fixed"
    />
    <div class="header-wrapper">
      <div class="header-left">
        <div class="module-header">
          <span class="poster-dashboard-widget__icon mdi mdi-format-list-bulleted-square" />
          <span class="poster-dashboard-widget__title module-title">
            {{ $t('poster.demands_synthesis.title', { count: synthesis.total }) }}
          </span>
        </div>
        <div class="input-wrapper">
          <pui-common-select
            ref="storesSelector"
            v-permission.undisplay="Permissions.SELECT_STORE"
            :taggable="false"
            :multiple="false"
            :display="piivoTranslate"
            :options="stores"
            :value="selectedStores"
            :label="$t('poster.demands_synthesis.store.label')"
            :placeholder="$t('poster.demands_synthesis.store.placeholder')"
            @select="updateSynthesis"
            @selectionCleared="updateSynthesis"
            class="module-select"
          />
          <pui-common-select
            ref="departmentsSelector"
            :display="piivoTranslate"
            :options="departments"
            :label="$t('poster.demands_synthesis.departement.label')"
            :placeholder="$t('poster.demands_synthesis.departement.placeholder')"
            @listUpdated="updateSynthesis"
            @selectionCleared="updateSynthesis"
            class="module-select"
          />
        </div>
      </div>
      <div class="header-right">
        <pui-button :flat="false" @click="showAll()" class="demands-vieall" variant="primary">
          {{ $t('poster.demands_synthesis.show_all') }}<i class="mdi mdi-chevron-right" />
        </pui-button>
      </div>
    </div>
    <div class="module-content scroll">
      <table class="records-list tableau_zebre">
        <thead>
          <tr>
            <th />
            <th
              v-for="(format, formatKey) in synthesis.formats"
              :key="formatKey"
              @click="showAndFilterByFormat(format)"
              class="center"
            >
              {{ format | piivoTranslate }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(type, typeKey) in synthesis.types" :key="typeKey">
            <td @click="showAndFilterByType(type)" class="first-column">
              {{ type | piivoTranslate }}
            </td>
            <td v-for="(typeValue, formatKey) in synthesis.formats" :key="formatKey" class="">
              <a
                v-if="synthesis.map[formatKey + 'x' + typeKey]"
                :title="$t('poster.demands_synthesis.type.view_corresponding_signage')"
                @click="showAndFilter(synthesis.map[formatKey + 'x' + typeKey])"
              >
                <p class="center notnull">{{ synthesis.map[formatKey + 'x' + typeKey].total }}</p>
              </a>
              <a v-else :title="$t('poster.demands_synthesis.type.no_corresponding_signage')">
                <!-- eslint-disable-next-line vue-i18n/no-raw-text -->
                <p class="center">-</p>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </poster-dashboard-widget>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

import services from '../../../../core/services';
import { LanguagesManagerService } from '../../../../core/services/languagesManagerService';
import store from '../../../../core/store';
import { Loader } from '../../../../utils/loader';
import { AttributeAlias, FilterAlias } from '../../constants';
import ConstantsMixin from '../../mixins/ConstantsMixin';
import {
  CLEAR_FILTERS,
  NAMESPACE as POSTER_NAMESPACE,
  RESET_SIGNAGES_PAGINATION,
  SET_FILTER,
  SET_SELECTED_SIGNAGES,
} from '../../store/modules/poster';
import { getPosterService } from '../../services';

export default {
  name: 'puiDemandsSynthesis',
  mixins: [ConstantsMixin],
  data() {
    return {
      piivoTranslate(value) {
        return Vue.filter('piivoTranslate')(value);
      },
      loader: new Loader(),
      removeSyncMessage: null,
      unsubDuringSync: null,
      unsubAfterSync: null,

      stores: [],
      departments: [],
      selectedStores: [],
      synthesis: {
        formats: {},
        types: {},
        map: {},
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
      types: `${POSTER_NAMESPACE}/globalTypes`,
    }),
  },
  methods: {
    // PiivoTranslate,
    /**
     * Update synthesis.
     */
    updateSynthesis() {
      const selectedStoresItems = this.$refs.storesSelector.getSelectedItems();
      const selectedDepartementsItems = this.$refs.departmentsSelector.getSelectedItems();
      const selectedStoreAlias =
        selectedStoresItems.length > 0 ? selectedStoresItems[0].alias : null;
      const selectedDepartmentsAlias = [];
      for (const department of selectedDepartementsItems) {
        selectedDepartmentsAlias.push(department.alias);
      }
      this.loadPendingSignagesSynthesis(selectedStoreAlias, selectedDepartmentsAlias);
    },
    /**
     * Show all signages.
     * Redirect to logs screen with store filter.
     * @param {Object} type (optional) : Type to filter
     * @param {Object} format (optional) : Format to filter
     */
    showAll() {
      this.showFilteredSignages();
    },
    /**
     * Show filtered signages for request parameter.
     * Redirect to logs screen with filters (store filter is always defined).
     * @param {Object} request : Object containing type and format to filter
     */
    showAndFilter(request) {
      this.showFilteredSignages(request.type, request.format);
    },
    /**
     * Show filtered signages for format parameter.
     * Redirect to logs screen with filters (store filter is always defined).
     * @param {Object} format : Format to filter
     */
    showAndFilterByFormat(format) {
      this.showFilteredSignages(null, format);
    },
    /**
     * Show filtered signages for type parameter.
     * Redirect to logs screen with filters (store filter is always defined).
     * @param {Object} type : Type to filter
     */
    showAndFilterByType(type) {
      this.showFilteredSignages(type);
    },
    /**
     * Show filtered signages for type and format parameters.
     * Redirect to logs screen with filters (store filter is always defined).
     * @param {Object} type (optional) : Type to filter
     * @param {Object} format (optional) : Format to filter
     */
    showFilteredSignages(type = null, format = null) {
      // Clear filters and selection
      store.commit(`${POSTER_NAMESPACE}/${CLEAR_FILTERS}`);
      store.commit(`${POSTER_NAMESPACE}/${SET_SELECTED_SIGNAGES}`, []);
      store.commit(`${POSTER_NAMESPACE}/${RESET_SIGNAGES_PAGINATION}`);
      const trackingProperties = {};

      // Set type, format and store filters
      if (type && this.types) {
        let testedType = null;
        for (const currentType of this.types) {
          let typeFound = false;
          if (currentType.itemId === type.itemId) {
            testedType = currentType;
            typeFound = true;
            break;
          } else {
            if (currentType.children && currentType.children.length > 0) {
              for (const currentSubType of currentType.children) {
                if (currentSubType.itemId === type.itemId) {
                  testedType = currentSubType;
                  typeFound = true;
                  break;
                }
              }
            }
          }
          if (typeFound === true) {
            break;
          }
        }

        // Set store type filter : parent type or children types
        if (testedType != null) {
          const typeFilter = [];
          if (testedType.children && testedType.children.length > 0) {
            typeFilter.push(...testedType.children);
          } else {
            typeFilter.push(testedType);
          }

          store.commit(`${POSTER_NAMESPACE}/${SET_FILTER}`, {
            name: FilterAlias.TYPE,
            value: typeFilter,
            operator: 'eq',
          });
          trackingProperties['type'] = type.alias;
        }
      }

      if (format) {
        store.commit(`${POSTER_NAMESPACE}/${SET_FILTER}`, {
          name: FilterAlias.FORMAT,
          value: [format],
          operator: 'eq',
        });
        trackingProperties['format'] = format.alias;
      }
      const selectedStoresItems = this.$refs.storesSelector.getSelectedItems();
      if (selectedStoresItems.length > 0 && selectedStoresItems[0].alias != null) {
        store.commit(`${POSTER_NAMESPACE}/${SET_FILTER}`, {
          name: FilterAlias.STORE,
          value: selectedStoresItems,
          operator: 'eq',
        });
        trackingProperties['store'] = selectedStoresItems[0].alias;
      }
      const selectedDepartementsItems = this.$refs.departmentsSelector.getSelectedItems();
      if (selectedDepartementsItems.length > 0) {
        store.commit(`${POSTER_NAMESPACE}/${SET_FILTER}`, {
          name: FilterAlias.DEPARTMENT,
          value: selectedDepartementsItems,
          operator: 'eq',
        });
        const depAlias = selectedDepartementsItems.map(d => d.alias);
        trackingProperties['departments'] = depAlias.join(',');
      }

      // Track logs filters
      services
        .getService('analytics')
        .trackEvent(this.Tracking.DASHBOARD_FILTER_LOGS, trackingProperties);

      // Navigate to signages list
      this.$router.push({ name: 'posterDemands' });
    },

    /**
     * Load signages synthesis for the store alias in parameter.
     * @param {String} selectedStoreAlias : Selected store alias
     * @param {Array} selectedDepartmentsAlias : Selected departments alias
     */
    async loadPendingSignagesSynthesis(selectedStoreAlias, selectedDepartmentsAlias = null) {
      const removeMessage = this.loader.addMessage();
      try {
        const lines = await getPosterService('signages').getPendingSignagesSynthesis(
          selectedStoreAlias,
          selectedDepartmentsAlias
        );
        // Build rows, columns and cells values
        this.synthesis.total = 0;
        this.synthesis.formats = {};
        this.synthesis.types = {};
        this.synthesis.map = {};
        for (const line of lines) {
          const formatAlias = line.format.alias;
          const typeAlias = line.type.alias;
          const mapKey = `${formatAlias}x${typeAlias}`;
          // Verify if type/format combination is not already present
          if (this.synthesis.map.hasOwnProperty(mapKey) === false) {
            this.synthesis.formats[formatAlias] = line.format;
            this.synthesis.types[typeAlias] = line.type;
            this.synthesis.map[mapKey] = {
              format: line.format,
              type: line.type,
              total: line.totalNumberOfItems,
            };

            // Sum number of items for global total
            this.synthesis.total += line.totalNumberOfItems;
          }
        }

        // Track metric corresponding to the number of signages to process
        services
          .getService('analytics')
          .trackMetric(this.Tracking.DASHBOARD_SIGNAGES_TO_PROCESS, this.synthesis.total, {
            store: selectedStoreAlias,
            department:
              selectedDepartmentsAlias && selectedDepartmentsAlias.length > 0
                ? selectedDepartmentsAlias.join(',')
                : null,
          });
      } catch (err) {
        services.getService('alerts').alertError(this.$t('poster.demands_synthesis.load.error'));
      }
      removeMessage();
    },
  },
  /**
   * Mounted hook.
   */
  async mounted() {
    // INIT Stores
    const results = await getPosterService('signages').getAttributeValues(AttributeAlias.STORE);

    // Build stores list
    this.stores = results;
    this.stores.push({
      alias: null,
      label: {
        fr_FR: 'Tous les magasins',
      },
    });

    // Sort stores list
    this.stores = this.stores.sort((a, b) => {
      const aLabel = a.label[LanguagesManagerService.getSelectedLocale()];
      const bLabel = b.label[LanguagesManagerService.getSelectedLocale()];
      if (aLabel === bLabel) {
        return 0;
      }
      if (aLabel > bLabel) {
        return 1;
      }
      if (aLabel < bLabel) {
        return -1;
      }
    });

    // Set default store
    const defaultStoreAlias = this.user.extendedProperties[AttributeAlias.STORE];
    // Search and set selected store
    this.selectedStores = [];
    if (defaultStoreAlias) {
      const store = this.stores.find(s => s.alias === defaultStoreAlias);
      if (store != null) {
        this.selectedStores.push(store);
      }
    }

    // INIT : Departments
    const attributeValuesResults = await getPosterService('signages').getAttributeValues(
      AttributeAlias.DEPARTMENT
    );

    // Build departments
    this.departments = attributeValuesResults;
    // Function to display Spinner when signages are not synchronized
    this.unsubDuringSync = getPosterService('signagesSync').actionDuringSynchronization(() => {
      if (this.removeSyncMessage) {
        this.removeSyncMessage();
        this.removeSyncMessage = null;
      }

      this.removeSyncMessage = this.loader.addMessage();
    });
    // Load signages synthesis (directly with selected values)
    this.unsubAfterSync = getPosterService('signagesSync').actionAfterSynchronization(() => {
      if (this.removeSyncMessage) {
        this.removeSyncMessage();
        this.removeSyncMessage = null;
      }

      this.loadPendingSignagesSynthesis(defaultStoreAlias);
    });
  },
  /**
   * Before destroy hook
   * */
  beforeDestroy() {
    // Unsubscribe from event listeners
    if (this.unsubDuringSync) {
      this.unsubDuringSync();
    }
    if (this.unsubAfterSync) {
      this.unsubAfterSync();
    }
  },
};
</script>
